import type { CSSProperties } from "react";

export const sectionClass = "relative z-[1] border-x border-b border-border";

export const pageBgStyle = {
	background:
		"radial-gradient(1200px 520px at -10% -15%, color-mix(in oklab, var(--primary) 18%, transparent), transparent 58%), radial-gradient(900px 420px at 112% -8%, color-mix(in oklab, var(--color-theme-denotives-violet) 10%, transparent), transparent 54%), linear-gradient(180deg, var(--color-primitives-coolneutral-7) 0%, var(--color-primitives-coolneutral-5) 48%, var(--color-primitives-coolneutral-5) 100%)",
} satisfies CSSProperties;
